import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { ExperienceAreaService } from '../experience-area.service';
import { ExperienceCoursesService } from './experience-courses.service';
import { ExperienceCoursesTab1Part } from './tabs/tab-1/experience-courses-tab-1.part';
import { ExperienceCoursesTab2Part } from './tabs/tab-2/experience-courses-tab-2.part';
import { ExperienceCoursesViewsPart } from './views/experience-courses-views.part';


@Component({
	selector: 'experience-courses-page',
	standalone: true,
	imports: [
		ExperienceCoursesTab1Part, ExperienceCoursesTab2Part, ExperienceCoursesViewsPart,
		PageTab1Directive, PageTab2Directive, PageTab3Directive, TrimesterDroplistWidget,
		DroplistWidget, ToolbarWidget,
		PageTabsWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './experience-courses.page.html',
})
export class ExperienceCoursesPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;
	public pageService = inject(ExperienceCoursesService);
	public areaService = inject(ExperienceAreaService);

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}